import { render, staticRenderFns } from "./ViolationComponent.vue?vue&type=template&id=af8cc0d6&"
import script from "./ViolationComponent.vue?vue&type=script&lang=ts&"
export * from "./ViolationComponent.vue?vue&type=script&lang=ts&"
import style0 from "./ViolationComponent.vue?vue&type=style&index=0&id=af8cc0d6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports